import { useState, useEffect } from "react";
import {
  BrandVariants,
  Theme,
  createDarkTheme,
  createLightTheme,
} from "@fluentui/react-components";

type BrandVariantsWithCenter = BrandVariants & { 85: string; 165: string };

// These are the color-contrast-safe brand variants of the purple theme seeded from the Figma color #8230FF
// Reference: https://react.fluentui.dev/?path=/story/themedesigner--page
const brandVariantsPurple: BrandVariantsWithCenter = {
  10: "#040207",
  20: "#1D112C",
  30: "#2F184F",
  40: "#3E1D6E",
  50: "#4E228E",
  60: "#5E27B0",
  70: "#6E2BD3",
  80: "#5B41FF",
  85: "#8230FF",
  90: "#8F43FF",
  100: "#9E58FF",
  110: "#AC6DFF",
  120: "#B880FF",
  130: "#C493FF",
  140: "#D0A6FF",
  150: "#DBB9FF",
  160: "#E5CCFF",
  165: "#E4E2FF",
};

export const lightTheme: Theme = {
  ...createLightTheme(brandVariantsPurple),
  colorPalettePurpleForeground2: brandVariantsPurple[85],
  colorPalettePurpleBackground2: brandVariantsPurple[165],
};

export const darkTheme: Theme = {
  ...createDarkTheme(brandVariantsPurple),
  colorPalettePurpleForeground2: brandVariantsPurple[85],
  colorPalettePurpleBackground2: brandVariantsPurple[165],
};

export const useThemeDetector = () => {
  const currentTheme = () => window.matchMedia("(prefers-color-scheme: dark)").matches;
  const [isDarkTheme, setIsDarkTheme] = useState(currentTheme());
  const mediaQueryListener = (event: { matches: boolean }) => {
    setIsDarkTheme(event.matches);
  };

  useEffect(() => {
    document.body.style.backgroundColor = isDarkTheme ? "#141414" : "#f5f5f5";
    const darkThemeMediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    darkThemeMediaQuery.addEventListener("change", mediaQueryListener);
    return () => darkThemeMediaQuery.removeEventListener("change", mediaQueryListener);
  }, [isDarkTheme]);
  return isDarkTheme;
};
